import { render } from "./QuizEditDialog.vue?vue&type=template&id=5e8c4af9"
import script from "./QuizEditDialog.vue?vue&type=script&lang=js"
export * from "./QuizEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__